import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline'
import ClearIcon from '@mui/icons-material/Clear'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Button, CircularProgress, Container, CssBaseline, FormControlLabel, Grid, Radio, RadioGroup, TextField } from "@mui/material"
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import Pagination from '@mui/material/Pagination'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { withStyles } from "@mui/styles"
import clsx from 'clsx'
import 'jspdf-autotable'
import moment from "moment"
import PropTypes from "prop-types"
import React, { Component } from "react"
import { FormattedMessage, injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import SimpleAutoComplete from "src/components/auto-complete/autocomplete-dialog-with-z-index"
import Api2Talk from "src/services/api2talk"
import { PapiroConsole } from "src/utils/papiroConsole"
import styled from 'styled-components'
import SimpleDatePicker from '../../components/date-pickers/inline-no-today'
import Footer from '../../components/footer'
import HeaderMenu from "../../components/header-menu"
import CustomizedSnackbars from "../../components/material-snackbars"
import MyMaterialTable from '../../components/table'
import { AbilityContext, Can } from '../../config/ability-context'
import * as calledsActions from '../../redux/actions/calleds'
import * as ItemService from '../../services/2talk/channel'
import Api from "../../services/api"
import ApiReports from "../../services/apireport"
import * as FileService from '../../services/attachment.service'
import { Overlay } from "../../styles/global"
import { Styles } from "../../styles/material-styles"

import AttachmentIcon from '@mui/icons-material/Attachment'
import { MESSAGE_PROVIDER_WHATSAPP } from 'src/utils/contantes/message-provider'
import { PROVIDER_CONFIG, PROVIDER_CONFIG_NAME } from 'src/utils/enums/provider-config'


const StyledTypography = styled(Typography)({

  cursor: 'pointer',
  '&:hover': {
    color: '#3f51b5',  // Cor ao passar o mouse
    textDecoration: 'underline',  // Sublinha o texto ao passar o mouse
  },
});


class ChatReport extends Component {

  constructor(props) {
    super(props)

    this.isClient = true
    this.isAdm = false
    this.typingTimeout = null
    this.organizationId = null

    const { userSession } = this.props

    if (userSession == null || userSession.user == null || userSession.user.userrole == null)
      Api.logoff()

    userSession.user.userrole.map((item, key) => {
      if (item.role.roletype != 3)
        this.isClient = false
      if (item.role.roletype == 0 || item.role.roletype == 1)
        this.isAdm = true
    });


    if (userSession.user.organization)
      this.organizationId = userSession.user.organization.id

    this.formDataInitialState = {
      MessageProviderId: null,
      channelId: null,
    }

    this.state = {
      formData: this.formDataInitialState,
      id: '',
      requestuser: '',
      assigned: '',
      channelOptions: [],
      optionsMessageProviders: [],
      dateStart: moment().format('YYYY/MM/DD HH:mm:ss'),
      dateEnd: moment().format('YYYY/MM/DD HH:mm:ss'),
      organizationId: this.organizationId,
      OrganizationFilter: 0,
      location: 0,
      loading: false,
      openNotification: false,
      notificationVariant: "error",
      notificationMessage: "",
      showGrid: false,
      calledsList: [],
      organizationList: [],
      organizationAddressesList: [],
      calledPdfList: [],
      totalPages: 0,
      page: 1,
      pageStart: 0,
      pageEnd: 0,
      count: 0,
      searchValue: '',
      showHeader: false,
      strhtmlModalOpen: false,
      dialogHTMLString: [],
      radioSelectedOption: "1",
      chatId: null

    }
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleAutocompleteChange = (name, value) => {
    this.setState({ [name]: value });
  };


  handleInputChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value });
  };




  handleChangeAutoComplete = async (stateName, value) => {
    let data = value.id > 0 ? value : null;

    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [stateName]: data
      }
    }));
  }

  openHTMLRenderModal = (item) => {

    this.setState({ loading: true })
    Api2Talk.get(`/chat/messages/bychat/${item.id}`)
      .then(result => {
        if (result.data.success) {
          PapiroConsole.log("result aqui")
          PapiroConsole.log(result)
          this.setState({ strhtmlModalOpen: !this.state.strhtmlModalOpen, dialogHTMLString: result.data.data, loading: false, chatId: item.id })
        } else {
          this.setState({
            loading: false, openNotification: true, notificationVariant: 'error',
            notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
          })
          Api.kickoff(result)
        }
      })
      .catch(err => {
        console.log("=== Catch(e) ===")
        console.log(err)
        this.setState({
          loading: false, openNotification: true, notificationVariant: "error",
          notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
        })
        Api.kickoff(err)
      })

  }

  closeHTMLRenderModal = () => {
    this.setState({ strhtmlModalOpen: !this.state.strhtmlModalOpen, dialogHTMLString: [], chatId: null })
  }

  changeValues = async (stateName, value, text = '') => {

    this.setState({ [stateName]: value });


  };

  Reload = () => {
    const reload = localStorage.getItem('reload')
    if (reload == "true")
      localStorage.setItem('reload', false)
    return null;
  }

  onChangePaginate = (e, page) => {
    this.setState({ page: page })
    this.getCalleds('', page)
  }

  exportPdf = _ => {
    this.getCalledsToPdf()
  }

  setPagination = (count, page) => {
    let totalPage = Math.ceil(count / 10)
    this.setState({ totalPages: totalPage })
    if (count > 0) {
      if (page == 1) {
        if (count < 10)
          this.setState({ pageStart: 1, pageEnd: count })
        else
          this.setState({ pageStart: 1, pageEnd: 10 })
      } else {
        let pageStart = ((page - 1) * 10) + 1
        if (count >= page * 10)
          this.setState({ pageStart: pageStart, pageEnd: page * 10 })
        else
          this.setState({ pageStart: pageStart, pageEnd: count })
      }
    } else
      this.setState({ totalPages: 0, page: 1, count: 0 })
  }


  async componentDidMount() {
    this.setState({ loading: true });
    await this.getChannelList()
    await this.fetchOptionsMessageProvider();
    this.setState({ loading: false });
  }

  fetchDataNotSuccess(result) {
    const intl = this.props.intl;
    this.setState({
      loading: false, openNotification: true, notificationVariant: "error",
      notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
    });
  }

  fetchDataThrowError(err) {
    const intl = this.props.intl;
    this.setState({
      loading: false, openNotification: true, notificationVariant: "error",
      notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
    });
  }

  // Função para buscar opções (provedores)
  fetchOptionsMessageProvider = async () => {

    Api2Talk.get(`/messageprovider`)
      .then(result => {

        if (result.data.success) {
          const messageProviderOptions = result.data.data;
          this.setState(prevState => ({
            optionsMessageProviders: messageProviderOptions
          }))
        } else {
          this.fetchDataNotSuccess(result);
          Api.kickoff(result);
        }
      })
      .catch(err => {
        this.setState({ loading: false });
        this.fetchDataThrowError(err);
        Api.kickoff(err);
      });
  }
  // Função para buscar opções (canais)
  async getChannelList() {

    const response = await ItemService.getChannelList();

    if (response.success) {
      const channels = response.data?.map(channel => ({ id: channel.id, name: channel.name, isdefault: false }));
      this.setState({ channelOptions: channels });
    } else {
      const intl = this.props.intl;
      this.setState({
        loading: false, openNotification: true, notificationVariant: "error",
        notificationMessage: response.data && response.data.response && response.data.response.data && response.data.response.data.errors && response.data.response.data.errors[0] ? response.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
      })
    }

  }



  getCalleds = async (filter = '', page = 1) => {
    const intl = this.props.intl;
    this.setState({ loading: true });

    let url = `/report/2talk-chat-report/paginate?page=${page}`

    url += `&dateStart=${moment(this.state.dateStart).format('YYYY-MM-DD')}&dateEnd=${moment(this.state.dateEnd).format('YYYY-MM-DD')}`
    if (this.state.formData.MessageProviderId && this.state.formData.MessageProviderId.id && this.state.formData.MessageProviderId.id > 0) {
      url += `&messageProviderId=${this.state.formData.MessageProviderId.id}`
    }
    if (this.state.formData.channelId && this.state.formData.channelId.id && this.state.formData.channelId.id > 0) {
      url += `&channelId=${this.state.formData.channelId.id}`
    }
    if (this.state.id && this.state.id > 0)
      url += `&id=${this.state.id}`
    if (this.state.requestuser && this.state.requestuser.length > 0)
      url += `&requestUser=${this.state.requestuser}`
    if (this.state.assigned && this.state.assigned.length > 0)
      url += `&assignedUser=${this.state.assigned}`
    this.setState({ showGrid: true })

    var writing = ""

    ApiReports.get(url)
      .then(result => {
        if (result.data.success) {

          console.log(result)
          console.log("result aqui")
          let count = result.data.count
          this.setState({ count: count })
          this.setPagination(count, page)

          let formattedList
          if (result.data.data.length > 0) {
            formattedList = result.data.data.map(item => {
              PapiroConsole.log("item.messageproviderid")
              PapiroConsole.log(item.messageproviderid)
              return {
                ...item,
                createdat: moment(item.createdat).format('DD/MM/YYYY HH:mm'),
                phone : item.messageproviderid == PROVIDER_CONFIG_NAME.WHATSAPP || item.messageproviderid == PROVIDER_CONFIG_NAME.WEBCHAT ? item.phone : '',  
                Message: <Tooltip title={intl.formatMessage({ id: "send.mail.report.view.email.body" })}>
                  <IconButton aria-label="textevidence"
                    onClick={e => this.openHTMLRenderModal(item)}>
                    <ChatBubbleOutlineIcon />
                  </IconButton>
                </Tooltip>
              }

            })
          }
          console.log("=== formattedList ===")
          console.log(formattedList)

          this.setState({ calledsList: formattedList, loading: false })
        } else {
          this.setState({
            loading: false, openNotification: true, notificationVariant: 'error',
            notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
          })
          Api.kickoff(result)
        }
      })
      .catch(err => {
        console.log("=== Catch(e) ===")
        console.log(err)
        this.setState({
          loading: false, openNotification: true, notificationVariant: "error",
          notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
        })
        Api.kickoff(err)
      })
  }



  handleRadioChange = (event) => {
    if (event.target.value == "1") {
      this.setState({ radioSelectedOption: event.target.value, dateStart: moment().format('YYYY/MM/DD HH:mm:ss'), dateEnd: moment().format('YYYY/MM/DD HH:mm:ss') })
    }
    else if (event.target.value == "2") {
      this.setState({ radioSelectedOption: event.target.value, dateStart: moment().startOf('month').format('YYYY/MM/DD HH:mm:ss'), dateEnd: moment().format('YYYY/MM/DD HH:mm:ss') })
    }
    else if (event.target.value == "3") {
      this.setState({ radioSelectedOption: event.target.value, dateStart: moment().format('YYYY/MM/DD HH:mm:ss'), dateEnd: moment().format('YYYY/MM/DD HH:mm:ss') })
    }

  }

  getExcel = async () => {

    this.setState({ loading: true });
    var url = '/report/2talk-chat-report/excell';

    url += `?dateStart=${moment(this.state.dateStart).format('YYYY-MM-DD')}&dateEnd=${moment(this.state.dateEnd).format('YYYY-MM-DD')}`

    await ApiReports.get(url)
      .then((response) => {
        PapiroConsole.log(response)
        PapiroConsole.log("response")
        if (response.data.success) {
          PapiroConsole.log("success")
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'success',
            notificationMessage: this.props.intl.formatMessage({ id: "report.sent" }) + " (" + this.props.userSession.user.email + ")",
          });
        } else {
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'error',
            notificationMessage: response.data.errors && response.data.errors[0] ? response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
          });
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          openNotification: true,
          notificationVariant: 'error',
          notificationMessage: error.data && error.data.response && error.data.response.data && error.data.response.data.errors && error.data.response.data.errors[0] ? error.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
        });
      });

    const intl = this.props.intl;

    this.setState({ loading: false });
  }

  getMessageExcellBadUseFlag = (message, status) => {
    const intl = this.props.intl;
    let writing = ""
    if (status === intl.formatMessage({ id: "finished" })) {
      if (message === true)
        writing = this.props.intl.formatMessage({ id: "yes" })
      else if (message === false)
        writing = this.props.intl.formatMessage({ id: "no" })
    } else
      writing = this.props.intl.formatMessage({ id: "undefined" })

    return writing
  }




  handleSubmit = async e => {
    const intl = this.props.intl;
    e.preventDefault();
    this.setState({ loading: true });


    var dateStart = moment(this.state.dateStart).format('YYYY-MM-DD')
    var dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD')
    if (dateStart > dateEnd) {

      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "report.audit.initial.date.higher.than.end.date" }),
        loading: false
      });

    } else {
      await this.getCalleds(this.props.location.state)
    }


  }

  closeNotification = _ => {
    this.setState({ openNotification: false });
  }

  renderDatePickerStart() {
    const { intl } = this.props
    return (
      <SimpleDatePicker label={intl.formatMessage({ id: "start.date" })} name='dateStart' stateName='dateStart' changeDate={this.changeValues} currentDate={this.state.dateStart} required />
    );
  }
  renderDatePickerEnd() {
    const { intl } = this.props
    return (
      <SimpleDatePicker label={intl.formatMessage({ id: "end.date" })} name='dateEnd' stateName='dateEnd' changeDate={this.changeValues} currentDate={this.state.dateEnd} required />
    );
  }
  convertHtmlOption = value => {
    PapiroConsole.log("=== convertHtmlOption ===")
    let body = value
    let temp = document.createElement("div")
    temp.innerHTML = body
    let found = null
    for (let i in temp.children) {
      if (temp.children[i].innerHTML && temp.children[i].innerHTML.toString().trim() != '<br>' && temp.children[i].innerHTML.toString().trim().length > 0) {
        found += temp.children[i].innerHTML.toString()
      }
    }
    let sanitized = temp.textContent.trim() || temp.innerText.trim() || found

    PapiroConsole.log(sanitized)
    return sanitized
  }

  getFile = async (hirerid, fileName, filerepositorymethod) => {

    const intl = this.props.intl;
    this.setState({ loading: true })

    await FileService.getFileByPath(hirerid, fileName, filerepositorymethod)
      .then(result => {
        if (result.data.success) {
          if (result && result.data && result.data.data && result.data.success) {
            window.open(`${result.data.data}`, '_blank');
          }
          this.setState({ loading: false })
        } else {
          this.setState({
            loading: false, openNotification: true, notificationVariant: 'error',
            notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
          })
          Api.kickoff(result)
        }
      })
      .catch(err => {
        console.log("=== Catch(e) ===")
        console.log(err)
        this.setState({
          loading: false, openNotification: true, notificationVariant: "error",
          notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
        })
        Api.kickoff(err)
      })
    //alert(JSON.stringify(url.data));


  };

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props
    const intl = this.props.intl


    if (Api == null) {
      var l = this.props.match.params.lang;
      document.location.href = `/${l}/unavailable`
    }

    console.log(this.state.dialogHTMLString)

    const tableList = () => {
      return (
        <>

          <Dialog scroll="paper" open={this.state.strhtmlModalOpen} onClose={this.closeHTMLRenderModal} aria-labelledby="form-dialog-title" fullWidth
            maxWidth="sm">

            <DialogTitle id="form-dialog-title" style={{ backgroundColor: '#3f50b5', color: 'white' }}>
              <span style={{ color: 'white', margin: '0px', padding: '0px' }}>{intl.formatMessage({ id: "messages.from.conversartion" })} - {this.state.chatId}</span>
              <ClearIcon onClick={this.closeHTMLRenderModal} style={{ fill: "white", float: 'right', cursor: 'pointer' }} />
            </DialogTitle>
            <DialogContent style={{ padding: '25px' }} >
              <div dividers style={{ maxHeight: '400px', overflowY: 'auto', }}>
                {this.state.dialogHTMLString.length > 0 ?
                  <div>

                    {this.state.dialogHTMLString.map((item) => {
                      if (((item.messageorigin === 4) || (item.messageorigin === 1))) {

                        //return <div style={{marginBottom : '23px'}}> <p style={{fontSize:'15px'}}><span style={{textTransform : 'uppercase'}}>{item.senderuser.name}</span> :  {item.message}</p> </div>
                        return (
                          <Card className={classes.root} style={{ marginBottom: '15px' }}>
                            <CardContent style={{ width: '100%' }} >
                              <Typography style={{ width: "100%" }} align="right" variant={'body2'} className={classes.title} color="textSecondary" gutterBottom>
                                {item.sendername} - {moment(item.createdat).format('DD/MM/YYYY HH:mm')}
                              </Typography>

                              {item.attachment != null &&


                                <StyledTypography style={{ width: "100%" }} inline variant="body1" align="right" onClick={() => this.getFile(item.attachment.hirerid, item.attachment.path, item.attachment.filerepositorymethod)} >
                                  <IconButton size="small">
                                    <AttachmentIcon />
                                  </IconButton>
                                  {item.message != null ? this.convertHtmlOption(item.message) : null}
                                </StyledTypography>


                              }
                              {item.attachment == null &&
                                <Typography style={{ width: "100%" }} inline variant="body1" align="right" >
                                  {item.message != null ? this.convertHtmlOption(item.message) : null}
                                </Typography>
                              }



                            </CardContent>
                          </Card>
                        )
                      }
                      else {
                        return (
                          <Card className={classes.rootClient} style={{ marginBottom: '15px' }}>
                            <CardContent>
                              <Typography component={'span'} variant={'body2'} className={classes.title} color="textSecondary" gutterBottom>
                                {item.sendername} - {moment(item.createdat).format('DD/MM/YYYY HH:mm')}
                              </Typography>

                              {item.attachment != null &&


                                <StyledTypography onClick={() => this.getFile(item.attachment.hirerid, item.attachment.path, item.attachment.filerepositorymethod)} >
                                  <IconButton size="small">
                                    <AttachmentIcon />
                                  </IconButton>
                                  {item.message != null ? this.convertHtmlOption(item.message) : null}
                                </StyledTypography>

                              }
                              {item.attachment == null &&
                                <Typography >
                                  {item.message != null ? this.convertHtmlOption(item.message) : null}
                                </Typography>
                              }
                            </CardContent>
                          </Card>
                        );
                      }

                    })}
                  </div>
                  : <h4> {intl.formatMessage({ id: "chat-report.no.messages.between.users" })}</h4>
                }




              </div>

            </DialogContent>
            <Grid container justify="flex-end" spacing={2} style={{ justifyContent: 'flex-end', marginBottom: '10px' }}>
              <Grid item xs={12} sm={12} md={3} style={{ marginRight: '20px' }}>
                <Button
                  onClick={this.closeHTMLRenderModal}
                  fullWidth
                  variant='contained'
                  color='secondary' >
                  {<FormattedMessage id="close" />}
                </Button>
              </Grid>
            </Grid>
          </Dialog>

          <form name='myForm' className={classes.form} onSubmit={this.handleSubmit} encType='multipart/form-data'>
            <Accordion >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={classes.heading}>{intl.formatMessage({ id: "filters" })}</Typography>

              </AccordionSummary>
              <AccordionDetails>
                <Grid fullWidth container spacing={2} style={{ marginBottom: 20 }}>
                  <Grid item xs={12} md={4} >
                    <TextField
                      fullWidth
                      label={intl.formatMessage({ id: "Id" })}
                      inputProps={{ maxLength: 40 }}
                      autoComplete='off'
                      type="number"
                      variant='outlined'
                      name='id'
                      onChange={this.handleInputChange}
                      value={this.state.id}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} >
                    <TextField
                      fullWidth
                      label={intl.formatMessage({ id: "Solicitante" })}
                      inputProps={{ maxLength: 40 }}
                      autoComplete='off'
                      type="text"
                      variant='outlined'
                      name='requestuser'
                      onChange={this.handleInputChange}
                      value={this.state.requestuser}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} >
                    <TextField
                      fullWidth
                      label={intl.formatMessage({ id: "Responsável" })}
                      inputProps={{ maxLength: 40 }}
                      autoComplete='off'
                      type="text"
                      variant='outlined'
                      name='assigned'
                      onChange={this.handleInputChange}
                      value={this.state.assigned}
                    />
                  </Grid>
                  <Grid item xs={12} md={12} >
                    <SimpleAutoComplete
                      name='channelId'
                      options={this.state.channelOptions} // Exemplo de opções para o autocomplete
                      label={intl.formatMessage({ id: "channel" })}
                      stateName='channelId'
                      changeSelect={(stateName, value) => this.handleChangeAutoComplete(stateName, value)}
                      selected={this.state.formData.channelId}
                      htmlOptions={true}
                    />
                  </Grid>
                  <Grid item xs={12} md={12} >
                    <SimpleAutoComplete
                      name="MessageProviderId"
                      label={intl.formatMessage({ id: "select.message_provider" })}
                      options={this.state.optionsMessageProviders}
                      stateName='MessageProviderId'
                      changeSelect={(stateName, value) => {
                        this.handleChangeAutoComplete(stateName, value)
                      }}
                      selected={this.state.formData.MessageProviderId}
                      htmlOptions={true}

                    />

                  </Grid>
                </Grid>
              </AccordionDetails>
              <AccordionDetails>
                <Typography className={classes.heading}>{intl.formatMessage({ id: "date" })}</Typography>
                <Grid container style={{ marginBottom: 20 }}>
                  <Grid item xs={12} md={12} lg={4}>
                    <RadioGroup
                      row
                      value={this.state.radioSelectedOption}
                      onChange={this.handleRadioChange}
                    >
                      <FormControlLabel value="1" control={<Radio />} label={intl.formatMessage({ id: "today" })} />
                      <FormControlLabel value="2" control={<Radio />} label={intl.formatMessage({ id: "current.month" })} />
                      <FormControlLabel value="3" control={<Radio />} label={intl.formatMessage({ id: "period" })} />
                    </RadioGroup>
                  </Grid>
                  {this.state.radioSelectedOption == "3" &&
                    <>
                      <Grid item xs={12} md={6} lg={4}>
                        {this.renderDatePickerStart()}
                      </Grid>
                      <Grid item xs={12} md={6} lg={4}>
                        {this.renderDatePickerEnd()}
                      </Grid>
                    </>
                  }

                </Grid>
              </AccordionDetails>
            </Accordion>


            <Grid container style={{ marginBottom: 10 }}>
              <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                <Button
                  type='submit'
                  fullWidth
                  variant='contained'
                  color='secondary' >
                  {<FormattedMessage id="filter" />}
                </Button>
              </Grid>
              {this.state.showGrid && <Grid item xs={6} sm={5} md={2} style={{ marginTop: 10, marginRight: 10 }}>
                <Button
                  fullWidth
                  variant='contained'
                  color='primary'
                  onClick={this.getExcel}
                >
                  {<FormattedMessage id="export.plan" />}
                </Button>
              </Grid>}
            </Grid>
          </form>

          {
            this.state.showGrid && <>
              <MyMaterialTable
                title=""
                columns={
                  [
                    { title: intl.formatMessage({ id: "id" }), field: 'id' },
                    { title: intl.formatMessage({ id: "date" }), field: 'createdat' },
                    {
                      title: intl.formatMessage({ id: "requestuser" }),
                      field: 'requestinguser',
                      render: (row) => {
                        return (row?.requestinguser && row?.requestinguser !== "")
                          ? <span>{row?.requestinguser}</span>
                          : <span>{row?.customername}</span>
                      }
                    },
                    { title: intl.formatMessage({id:"requester.number"}), field: 'phone' },
                    { title: intl.formatMessage({ id: "assigned" }), field: 'assigneduser' },
                    { title: intl.formatMessage({ id: "channel" }), field: 'channelname' },
                    { title: intl.formatMessage({ id: "ProviderType" }), field: 'messageprovidername' },
                    { title: intl.formatMessage({ id: "conversation" }), field: 'Message' },
                  ]}
                data={this.state.calledsList} />

              <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                <Grid item xs={12} md={3}>
                  <Pagination count={this.state.totalPages} page={this.state.page} onChange={this.onChangePaginate} />
                </Grid>
                <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                  {this.state.pageStart} {<FormattedMessage id="to" />} {this.state.pageEnd} {<FormattedMessage id="of" />} {this.state.count} {<FormattedMessage id="register" />}
                </Grid>
              </Grid>
            </>
          }
        </>
      );
    }

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })} >
          <div className={classes.drawerHeader} />
          <Container component='main' maxWidth='xl' style={{ maxWidth: '100%', paddingLeft: 0, marginLeft: 0 }}>
            <CssBaseline />


            <Grid container spacing={6}>
              <Grid item xs={12} sm={12}>
                <Card >
                  <CardContent className="background-title-search">
                    <Typography variant="h5">
                      {<FormattedMessage id="requested.chats" />}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            <Can I="List" a="ChatReport">
              {tableList()}
            </Can>

            {this.state.loading && (
              <Overlay>
                <CircularProgress color="secondary" />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification} />
          </Container>
        </main>
        <Footer />
      </div>
    )
  }
}

ChatReport.propTypes = {
  classes: PropTypes.object.isRequired
}


const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(calledsActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(ChatReport)))
ChatReport.contextType = AbilityContext